import { getValue, setValue, isNullOrUndefined } from '@syncfusion/ej2-base';
import { clearTemplate, registerEvents } from './util';
const refRegex = /Ref$/;
export class ComplexBase {
    constructor() {
        this.hasChanges = false;
        this.propCollection = {};
        this.dataSource = {};
        this.tags = [];
        this.tagObjects = [];
    }
    ngOnInit() {
        this.registeredTemplate = {};
        for (const tag of this.tags) {
            const objInstance = getValue('child' + tag.substring(0, 1).toUpperCase() + tag.substring(1), this);
            if (objInstance) {
                this.tagObjects.push({ instance: objInstance, name: tag });
            }
        }
        let templateProperties = Object.keys(this);
        for (let i = 0; i < templateProperties.length; i++) {
            const tempProp = getValue(templateProperties[parseInt(i.toString(), 10)], this);
            if (typeof tempProp === 'object' && tempProp && tempProp.elementRef) {
                if (!getValue(templateProperties[parseInt(i.toString(), 10)].indexOf('Ref') !== -1 ? templateProperties[parseInt(i.toString(), 10)] : templateProperties[parseInt(i.toString(), 10)] + 'Ref', this)) {
                    setValue(templateProperties[parseInt(i.toString(), 10)].indexOf('Ref') !== -1 ? templateProperties[parseInt(i.toString(), 10)] : templateProperties[parseInt(i.toString(), 10)] + 'Ref', tempProp, this);
                }
                if (getValue('viewContainerRef', this) && !getValue('_viewContainerRef', tempProp.elementRef.nativeElement) && !getValue('propName', tempProp.elementRef.nativeElement)) {
                    setValue('_viewContainerRef', getValue('viewContainerRef', this), tempProp.elementRef.nativeElement);
                    setValue('propName', templateProperties[parseInt(i.toString(), 10)].replace('Ref', ''), tempProp.elementRef.nativeElement);
                }
            }
        }
        templateProperties = Object.keys(this);
        templateProperties = templateProperties.filter((val) => {
            return /Ref$/i.test(val);
        });
        for (const tempName of templateProperties) {
            const propName = tempName.replace('Ref', '');
            setValue(propName.replace('_', '.'), getValue(propName, this), this.propCollection);
        }
        // Angular 9 compatibility to overcome ngOnchange not get triggered issue
        // To Update properties to "this.propCollection"
        const propList = Object.keys(this);
        /* istanbul ignore next */
        if (this.directivePropList) {
            for (let k = 0; k < this.directivePropList.length; k++) {
                const dirPropName = this.directivePropList[parseInt(k.toString(), 10)];
                if (propList.indexOf(dirPropName) !== -1 && (getValue(dirPropName, this) === false || getValue(dirPropName, this))) {
                    setValue(dirPropName, getValue(dirPropName, this), this.propCollection);
                }
            }
            this.hasChanges = true;
        }
        this.isInitChanges = true;
    }
    registerEvents(eventList) {
        registerEvents(eventList, this, true);
    }
    ngOnChanges(changes) {
        for (const propName of Object.keys(changes)) {
            const changedVal = changes[`${propName}`];
            this.propCollection[`${propName}`] = changedVal.currentValue;
        }
        this.isUpdated = false;
        this.hasChanges = true;
    }
    /* istanbul ignore next */
    clearTemplate(templateNames) {
        clearTemplate(this, templateNames);
    }
    getProperties() {
        /* istanbul ignore next */
        for (const tagObject of this.tagObjects) {
            this.propCollection[tagObject.name] = tagObject.instance.getProperties();
        }
        return this.propCollection;
    }
    isChanged() {
        let result = this.hasChanges;
        if (!isNullOrUndefined(this.propCollection[this.property])) {
            const tempProps = this.propCollection[this.property];
            const props = Object.keys(tempProps[0]);
            for (let d = 0; d < props.length; d++) {
                if (!isNullOrUndefined(this.propCollection[props[parseInt(d.toString(), 10)]])) {
                    const val = getValue(props[parseInt(d.toString(), 10)], this);
                    const propVal = this.propCollection[this.property][0][props[parseInt(d.toString(), 10)]];
                    if (!isNullOrUndefined(val) && this.propCollection[props[parseInt(d.toString(), 10)]] !== val
                        && propVal !== val) {
                        setValue(props[parseInt(d.toString(), 10)], val, this.propCollection[this.property][0]);
                        setValue(props[parseInt(d.toString(), 10)], val, this.propCollection);
                        this.hasChanges = true;
                        this.isUpdated = false;
                    }
                }
            }
        }
        /* istanbul ignore next */
        for (const item of this.tagObjects) {
            result = result || item.instance.hasChanges;
        }
        return result || this.hasChanges;
    }
    ngAfterContentChecked() {
        this.hasChanges = this.isChanged();
        if (this.isInitChanges || this.hasChanges) {
            let templateProperties = Object.keys(this);
            templateProperties = templateProperties.filter((val) => {
                return refRegex.test(val);
            });
            for (const tempName of templateProperties) {
                const propName = tempName.replace('Ref', '');
                setValue(propName.replace('_', '.'), getValue(propName, this), this.propCollection);
            }
        }
    }
    ngAfterViewChecked() {
        /* istanbul ignore next */
        if (this.isUpdated) {
            this.hasChanges = false;
        }
    }
    ngAfterViewInit() {
        /* istanbul ignore next */
        this.isInitChanges = false;
    }
    ngOnDestroy() {
        /* istanbul ignore next */
        this.directivePropList = [];
    }
}
export class ArrayBase {
    constructor(propertyName) {
        this.list = [];
        this.hasChanges = false;
        this.propertyName = propertyName;
    }
    ngOnInit() {
        this.isInitChanges = true;
    }
    ngAfterContentInit() {
        let index = 0;
        /* istanbul ignore next */
        this.list = this.children.map((child) => {
            child.dirIndex = index++;
            child.property = this.propertyName;
            return child;
        });
        this.hasChanges = true;
    }
    getProperties() {
        const onlyProp = [];
        for (const item of this.list) {
            onlyProp.push(item.getProperties());
        }
        return onlyProp;
    }
    isChanged() {
        let result = false;
        let index = 0;
        let isSourceChanged = false;
        const childrenDataSource = this.children.map((child) => {
            return child;
        });
        /* istanbul ignore next */
        if (this.list.length === this.children.length) {
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[parseInt(i.toString(), 10)].propCollection.dataSource) {
                    if (this.list[parseInt(i.toString(), 10)].dataSource &&
                        this.list[parseInt(i.toString(), 10)].propCollection.dataSource
                            !== this.list[parseInt(i.toString(), 10)].dataSource) {
                        this.list[parseInt(i.toString(), 10)].propCollection.dataSource = this.list[parseInt(i.toString(), 10)].dataSource;
                        this.list[parseInt(i.toString(), 10)].hasChanges = true;
                    }
                    if (this.list[parseInt(i.toString(), 10)].property !== 'series') {
                        isSourceChanged = (JSON.stringify(this.list[parseInt(i.toString(), 10)].propCollection.dataSource) !==
                            JSON.stringify(childrenDataSource[parseInt(i.toString(), 10)].propCollection.dataSource));
                    }
                }
                isSourceChanged = this.list[parseInt(i.toString(), 10)].hasChanges
                    !== childrenDataSource[parseInt(i.toString(), 10)].hasChanges;
            }
        }
        this.hasNewChildren = (this.list.length !== this.children.length || isSourceChanged) ? true : null;
        if (this.hasNewChildren) {
            this.list = this.children.map((child) => {
                child.dirIndex = index++;
                child.property = this.propertyName;
                return child;
            });
        }
        /* istanbul ignore end */
        for (const item of this.list) {
            result = result || item.hasChanges;
        }
        return !!this.list.length && result;
    }
    clearTemplate(templateNames) {
        /* istanbul ignore next */
        for (const item of this.list) {
            item.clearTemplate(templateNames && templateNames.map((val) => {
                const regExp = RegExp;
                return new regExp(this.propertyName).test(val) ? val.replace(this.propertyName + '.', '') : val;
            }));
        }
    }
    ngAfterContentChecked() {
        this.hasChanges = this.isChanged();
        for (let i = 0; i < this.list.length; i++) {
            if (getValue('childColumns', this.list[parseInt(i.toString(), 10)]) && getValue('property', this.list[parseInt(i.toString(), 10)]) === 'columns') {
                setValue('columns', getValue('childColumns', this.list[parseInt(i.toString(), 10)]).getProperties(), this.list[parseInt(i.toString(), 10)].propCollection);
            }
            this.list[parseInt(i.toString(), 10)].isUpdated = true;
        }
    }
    ngAfterViewInit() {
        this.isInitChanges = false;
    }
    ngOnDestroy() {
        this.list = [];
    }
}
